/**
* PAGE SCROLLING
* Internal anchor and top-of-page scrolling
*/


// jQuery Smooth Scroll
(function($) {

    $(".js-scroll, #scroll-to-top, .jumpNav__link").not('.-tab-toggle > li a').on("click", function(e) {
        if (this.hash !== "") {
            e.preventDefault();

            // default offset when #masthead is not present
            const hash = this.hash;
            let offset = 50; 

            // if #masthead exists, use its outerHeight for offset instead 
            if ($("#masthead").length > 0) {
                offset = $("#masthead").outerHeight();
            }

            // scroll to target with appropriate offset 
            $("html, body").animate( 
              { scrollTop: $(hash).offset().top - offset + "px" }
              , 500
            );
        }
    });

})(jQuery);




// show scrollup button after scrolling 300px
scrollToTopButton = document.getElementById("scroll-to-top");
var showScrollToTop = function () {
  var y = window.scrollY;
  if (y >= 300) {
    scrollToTopButton.style.opacity = "1";
  } else {
    scrollToTopButton.style.opacity = "0";
  }
};
window.addEventListener("scroll", showScrollToTop);






// console.log('scroll to top loaded');
